import * as Yup from "yup";

export function initialValues(competence) {
  return {
    code: competence?.code || "",
    name: competence?.name || "",
    description: competence?.description || "",
    levelId: competence?.grade?.levelId || competence?.levelId || "",
    subjectId: competence?.subjectId || "",
    gradeId: competence?.gradeId || "",
    order: competence?.order || 1,
  };
}

export function validationSchema() {
  return Yup.object({
    code: Yup.string()
      .required("El código es obligatorio")
      .matches(
        /^[A-Z]{2,4}-C[0-9]+$/,
        "El formato debe ser XXX-C1 (ej: MAT-C1, COM-C2)",
      ),
    name: Yup.string().required("El nombre es obligatorio"),
    description: Yup.string(),
    levelId: Yup.number().required("El nivel es obligatorio"),
    subjectId: Yup.number().required("La asignatura es obligatoria"),
    gradeId: Yup.number().required("El grado es obligatorio"),
    order: Yup.number()
      .min(1, "El orden debe ser mayor a 0")
      .required("El orden es obligatorio"),
  });
}
